import * as jsxRuntime from "/Users/cx/Documents/Web/capitaland-business/sass-manager/kuban-web/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment